var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimRfidCardReader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_31612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.12481 5.1458C6.58758 2.89662 9.12289 1.40606 12.0001 1.40606C14.8773 1.40606 17.4126 2.89662 18.8754 5.1458L20.0549 4.38132C18.3412 1.74628 15.3709 0 12.0001 0C8.62927 0 5.65902 1.74623 3.94531 4.38132L5.12481 5.1458Z",
    fill: "rgb(45, 169, 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.877 6.93002C8.7542 5.58119 10.2746 4.68731 12.0001 4.68731C13.7255 4.68731 15.246 5.58119 16.1232 6.93002L17.3027 6.16554C16.1745 4.43084 14.2191 3.28125 12.0001 3.28125C9.78104 3.28125 7.82568 4.43084 6.69751 6.16554L7.877 6.93002Z",
    fill: "rgb(45, 169, 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3986 9.66492C21.968 9.43156 21.4752 9.29888 20.9519 9.29888H16.4994V10.7049H20.9519C21.8564 10.7049 22.5923 11.4408 22.5923 12.3453V20.9535C22.5923 21.858 21.8564 22.5939 20.9519 22.5939H3.04817C2.14365 22.5939 1.40777 21.858 1.40777 20.9535V12.3453C1.40777 11.4408 2.14365 10.7049 3.04817 10.7049H7.50068V9.29883H3.04817C2.52493 9.29883 2.03215 9.43151 1.60147 9.66487C0.64962 10.1807 0.00170898 11.1887 0.00170898 12.3453V20.9535C0.00170898 22.6333 1.36835 24 3.04817 24H20.9519C22.6317 24 23.9984 22.6333 23.9984 20.9535V12.3453C23.9984 11.1887 23.3505 10.1807 22.3986 9.66492Z",
    fill: "rgb(45, 169, 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5625C10.4418 6.5625 9.17871 7.82561 9.17871 9.38375C9.17871 10.9419 10.4418 12.205 12 12.205C13.5581 12.205 14.8212 10.9419 14.8212 9.38375C14.8212 7.82566 13.5581 6.5625 12 6.5625ZM12 10.799C11.2195 10.799 10.5845 10.164 10.5845 9.38343C10.5845 8.60292 11.2195 7.9679 12 7.9679C12.7805 7.9679 13.4154 8.60288 13.4154 9.38343C13.4154 10.164 12.7805 10.799 12 10.799Z",
    fill: "rgb(45, 169, 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7921 20.5L7 16.7079L7.94802 15.7599L10.7921 18.604L16.896 12.5L17.8441 13.448L10.7921 20.5Z",
    fill: "rgb(45, 169, 226)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_31612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRfidCardReader);
export default __webpack_public_path__ + "static/media/claimRFIDCardReader.c62f264af0d8f93f641d9872cf1a9206.svg";
export { ForwardRef as ReactComponent };